$(document).ready(function(){
    $('.button--video').click(function(){
        console.log('clicked!');
        var youtube = $(this).attr('data-youtube');
        var youtube_id = youtube.split('v=')[1];
        var youtube_embed = 'https://www.youtube.com/embed/'+youtube_id+'?autoplay=1';
        $('.vts_video_hld_banner').css('display','flex');
        $('.vts_video').html('<iframe width="100%" height="100%" loading="lazy" src="'+youtube_embed+'" frameborder="0" allow="autoplay; encrypted-media; gyroscope; picture-in-picture" scrolling="no"></iframe>');
        $('.vts_video').addClass('vts_video_hld_active');
    });
    $('.vts_video_hld_banner').click(function(){
        $('.vts_video_hld_banner').css('display','none');
        $('.vts_video').removeClass('vts_video_hld_active');
        $('.vts_video').html('');
        console.log('clicked2');
    });
    $(document).keydown(function(e) {
        if (e.key == "Escape") { // escape key maps to keycode `27`
            $('.vts_video_hld_banner').css('display','none');
            $('.vts_video').removeClass('vts_video_hld_active');
            $('.vts_video').html('');
        }
    });
});

//Remove/show image according to screen size
document.addEventListener('DOMContentLoaded', function () {
  const bannerV2Images = document.querySelectorAll('.banner-v2-image');

  const updateImage = (image, isDesktop) => {
    if (image.dataset.src) {
      image.src = image.dataset.src;
      image.removeAttribute("data-src");
    }
    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      image.removeAttribute("data-srcset");
    }
  };

  const checkImages = () => {
    bannerV2Images.forEach((image) => {
      const desktopImage = image.closest('.banner_image_desktop');
      const mobileImage = image.closest('.banner_image_mobile');
      
      if (image.src && !image.dataset.src) {
        image.dataset.src = image.src;
        image.removeAttribute("src");
      }
      if (image.srcset && !image.dataset.srcset) {
        image.dataset.srcset = image.srcset;
        image.removeAttribute("srcset");
      }

      if (desktopImage && window.innerWidth >= 750) {
        updateImage(image, true);
      } else if (mobileImage && window.innerWidth < 750) {
        updateImage(image, false);
      }
    });
  };

  checkImages();

  window.addEventListener('resize', function () {
    checkImages();
  });
});

